import { useTranslation } from "react-i18next";

import {
  formatScriptAge,
  formatScriptCreatedAt,
  formatScriptCreatedAtShort,
} from "../../../lib/persona-script-meta.js";

/** Generated at cell: age first for scanning, the date beneath, the full timestamp on hover. */
export function OpportunityHubScriptGeneratedAt({
  createdAt,
  now = Date.now(),
}: {
  /** ISO timestamp. */
  createdAt: string;
  now?: number;
}) {
  const { i18n } = useTranslation();
  const age = formatScriptAge(createdAt, i18n.language, now);
  if (!age) return null;

  return (
    <time
      dateTime={createdAt}
      title={formatScriptCreatedAt(createdAt, i18n.language)}
      className="flex flex-col gap-0.5 tabular-nums"
    >
      <span className="text-xs text-foreground">{age}</span>
      <span className="text-[11px] text-muted-foreground">
        {formatScriptCreatedAtShort(createdAt, i18n.language, now)}
      </span>
    </time>
  );
}
